<template>
    <!-- <div id="app" class="my-0 py-0">
     <v-app id="inspire">
       <v-form ref="form" v-model="valid" :lazy-validation="lazy"> -->
        <div>
         <v-card v-model="show" class="py-0">
           <v-toolbar class="py-0 my-0" dark color="blue">
             
              
                <v-row>
                        <v-col cols = "2">

                            <v-toolbar-title  class="my-0 py-0">
                                Ficha de Materiales
                            </v-toolbar-title>
                        </v-col>   
                            
                    
                        <v-spacer></v-spacer>

                        <v-col cols="auto" class="d-flex justify-end">
                            <v-btn dense color="success"  @click="ajuste()"
                            class="mx-1">
                                    Ajuste Precio
                            </v-btn>
                            <v-btn dense color="success"  @click="guardarNuevo()"
                            class="mx-1">
                                    Guardar
                            </v-btn>
                           

                        </v-col>    

                        <!-- <v-col cols = "2">

                            <v-btn dense color="success"  @click="ajuste()">
                                    Ajuste Precio
                            </v-btn>

                        </v-col>
                        
                        <v-col cols = "1">

                            <v-btn dense color="success"  @click="guardarNuevo()">
                                    Guardar
                            </v-btn>
                    
                        </v-col> -->

                </v-row>
             
             
             

             <!-- <v-btn color="success" @click="guardarMaterial()">
                 Guardar
             </v-btn> -->
             
           </v-toolbar>
         </v-card>

         <v-tabs background-color="#02AC66" dark show-arrows>
 
          <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
          <v-tab> Materiales de Taller </v-tab>        
          <v-tab> Servicios de terceros </v-tab>
          <v-tab> Gastos Indirecto </v-tab>
          <v-tab> Mano de Obra </v-tab>
          <v-tab> Provisión de Deposito </v-tab>
          
          <!-- <v-tab> Materiales Varios </v-tab> -->
          
          <v-tab-item>

            <v-form color="blue lighten-4" class="py-0 my-0">
                <!-- <v-card color="blue lighten-4" class="py-0 my-0">
                    
                    <v-card-text class="py-0 my-0">   -->
                    <v-row dense>
                    <v-col cols="12" sm="12" md="12"> 
                            <v-data-table
                                :headers="headers"                                                                      
                                class="elevation-1"
                                                                   
                                fixed-header
                                :items-per-page="desserts.length"
                                item-key="name"
                                :search="search"
                                :custom-filter="filterOnlyCapsText"
                                dense
                                :items="desserts" 
                                
                            
                                

                            > 
                            
                                <!-- <template v-slot:item.codigoMate="{ item }">
                                    <v-select para el campo tipoM 
                                    <v-select
                                    :items="matTaller"
                                    v-model="item.codigoMate"
                                    dense                     
                                    ></v-select>
                                </template> --> 
                                

                            
                                
                                <template v-slot:item.nombre="{ item }"> 
                                        <v-text-field 
                                        v-model="item.nombre"  
                                        dense
                                        
                                    
                                    
                                        >
                                        </v-text-field> 
                                </template>
                                <template v-slot:item.dolar="{ item }"> 
                                        <v-text-field 
                                        v-model="item.dolar"  
                                        dense
                                        
                                        type="number"  
                                        >
                                        </v-text-field> 
                                </template>
                                <template v-slot:item.pesos="{ item }"> 
                                    <v-text-field 
                                    v-model="item.pesos"  
                                    dense
                                    
                                    type="number"  
                                    >
                                    </v-text-field>
                                </template>

                                <template v-slot:item.idproducto1="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto1"  color="blue">

                                  </v-checkbox>
                                </template>

                                <template v-slot:item.idproducto2="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto2">

                                  </v-checkbox>
                                </template>


                                <template v-slot:item.idproducto3="{ item }"> 
                                  <v-checkbox v-model="item.idproducto3">

                                  </v-checkbox>
                                </template>

                                <template v-slot:item.idproducto4="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto4">

                                  </v-checkbox>
                                </template>

                                <template v-slot:top>
                                    <v-row>                                     

                                        <v-col cols="2" sm="2" md="2" >
                                            <v-btn x-small color="success" @click="activarDialogo(11)">
                                                Agregar Fila Chapa 
                                            </v-btn>
                                        </v-col>

                                        <v-col cols="2" sm="2" md="2" >
                                            <v-btn x-small color="success" @click="activarDialogo(22)"> 
                                                Agregar Fila Materiales
                                            </v-btn>
                                        </v-col>
                                    
                                        <!-- <v-col cols="1" sm="1" md="1" > 
                                            <v-btn x-small color="success"   @click="Guardar(11)">
                                            Guardar Taller
                                            </v-btn>
                                        </v-col> -->

                                        <v-col cols="5" sm="5" md="5">
                                            <v-text-field
                                                v-model="search"
                                                label="Buscar por Nombre"
                                                class="mx-4"
                                                @input="convertirAMayusculas(search,1)"
                                                dense
                                            ></v-text-field>

                                        </v-col>

                                    </v-row>
                                
                                    
                                </template>

                                <template v-slot:[`item.actions`]="{ item }">
                                                <!-- <v-icon
                                                    color="red"
                                                    small
                                                    class="mr-2"
                                                    @click="editItem(item)"
                                                    dense                                          
                                                >
                                                    mdi-pencil
                                                </v-icon> -->

                                                <v-icon
                                                    color="red"
                                                    small
                                                    @click="deleteItem(item,1)"                                           
                                                    class="mx-2" 
                                                    dense
                                                >
                                                    mdi-delete
                                                </v-icon> 

                                                <v-icon
                                                    color="red"
                                                    small
                                                    @click="historial(item,1)"                                           
                                                    class="mx-2" 
                                                    dense
                                                >
                                                mdi-history
                                                </v-icon> 


                                </template>
                            </v-data-table>
                        </v-col> 
                    </v-row>  
                                    
                    <!-- </v-card-text> 
                    
                </v-card> -->
            </v-form>
        

          </v-tab-item> 
          
          
          <v-tab-item>

                <!-- <v-card color="blue lighten-4" class="py-0 my-0">
                <v-card-text class="py-0 my-0"> -->
                <v-form>
                    <v-row dense>
                    <v-col cols="12" sm="12" md="12">
                            <v-data-table
                                :headers="headersTerc"
                                :items="terCan ? dessertsTerConCantidades : dessertsTer"                                                
                                class="elevation-1"
                                                                   
                                fixed-header
                                :items-per-page="dessertsTer.length"
                                item-key="name"
                                :search="search1"
                                :custom-filter="filterOnlyCapsText"
                                dense

                            > 
                            
                                <template v-slot:item.nombre="{ item }"> 
                                            <v-text-field 
                                            v-model="item.nombre"  
                                            dense
                                            
                                        
                                            >
                                            </v-text-field> 
                                </template>
                            
                                                            
                                <template v-slot:item.dolar="{ item }">
        
                                        <v-text-field 
                                        v-model="item.dolar"  
                                        dense
                                        
                                        type="number"  

                                            
                                        >
                                        </v-text-field>
        
                                </template>

                                <template v-slot:item.pesos="{ item }">
        
                                    <v-text-field 
                                    v-model="item.pesos"  
                                    dense
                                    type="number"  

                                        
                                    >
                                    </v-text-field>

                                </template>


                                <template v-slot:item.idproducto1="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto1"  color="blue">

                                  </v-checkbox>
                                </template>

                                <template v-slot:item.idproducto2="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto2">

                                  </v-checkbox>
                                </template>


                                <template v-slot:item.idproducto3="{ item }"> 
                                  <v-checkbox v-model="item.idproducto3">

                                  </v-checkbox>
                                </template>

                                <template v-slot:item.idproducto4="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto4">

                                  </v-checkbox>
                                </template>


                                

                                <template v-slot:top>
                                    <v-row>
                                        <!-- <v-col cols="3" sm="3" md="3">

                                            <v-toolbar flat dense>
                                                <v-toolbar-title center>
                                                <font color="red" dense>
                                                Servicios Terciarizados
                                                </font>
                                                </v-toolbar-title>
                                
                                            </v-toolbar>


                                        </v-col> -->

                                        <v-col cols="1" sm="1" md="1" >
                                            <v-btn  x-small color="success" @click="activarDialogo(2)">
                                                Agregar Fila
                                            </v-btn>
                                        </v-col>

                                        <!-- <v-col cols="2" sm="2" md="2" >
                                            <v-btn   x-small color="success" @click="Guardar(2)">
                                            Guardar Serv. Terc.
                                            </v-btn>
                                        </v-col> -->

                                        <v-col cols="8" sm="8" md="8">                                    
                                                <v-text-field
                                                v-model="search1"
                                                label="Buscar por Nombre"
                                                class="mx-4"
                                                @input="convertirAMayusculas(search1,2)"
                                                ></v-text-field>
                                        </v-col>

                                    </v-row>
                                </template>

                                <template v-slot:[`item.actions`]="{ item }">

                                                <!-- <v-icon
                                                    color="red"
                                                    small
                                                    class="mr-2"
                                                    @click="editItem(item)"
                                                
                                                >
                                                    mdi-pencil
                                                </v-icon> -->

                                                <v-icon
                                                    color="red"
                                                    small
                                                    @click="deleteItem(item,2)"                                           
                                                    class="mx-2" 
                                                >
                                                    mdi-delete
                                                </v-icon>


                                                <v-icon
                                                    color="red"
                                                    small
                                                    @click="historial(item,2)"                                           
                                                    class="mx-2" 
                                                    dense
                                                >
                                                mdi-history
                                                </v-icon> 
                                                

                                </template>
        
                                
                            </v-data-table>
                        </v-col>
                        
                    </v-row>
                       
                    <!-- </v-card-text>
                    </v-card> -->

                </v-form>

          </v-tab-item>
          
          

          <v-tab-item>

                <!-- <v-card color="blue lighten-4" class="py-0 my-0">
          <v-card-text class="py-0 my-0"> -->

                <v-form>
                    <v-row dense>
                    <v-col cols="12" sm="12" md="12">
                            <v-data-table
                                :headers="headersGI"
                                :items="dessertsGI"                                                
                                class="elevation-1"
                                height="200"                                   
                                fixed-header
                                :items-per-page="dessertsGI.length"
                                dense
                            >                        
                                
                            
                                <template v-slot:item.nombre="{ item }"> 
                                            <v-text-field 
                                            v-model="item.nombre"  
                                            dense
                                            
                                        
                                            >
                                            </v-text-field> 
                                </template>

                                <template v-slot:item.pesos="{ item }">

                                        <v-text-field 
                                        v-model="item.pesos"  
                                        dense
                                        
                                        
                                        >
                                        </v-text-field>

                                </template>

                                
                                <template v-slot:item.dolar="{ item }">

                                    <v-text-field 
                                    v-model="item.dolar"  
                                    dense
                                    
                                
                                    >
                                    </v-text-field>

                                </template>


                                <template v-slot:top>
                                    <v-row>
                                        <v-col cols="2" sm="2" md="2">

                                            <!-- <v-toolbar flat dense>
                                                <v-toolbar-title center>
                                                <font color="red" dense>
                                                Gastos Indirectos
                                                </font>
                                                </v-toolbar-title>
                                
                                            </v-toolbar> -->


                                        </v-col>

                                        <!-- <v-col cols="2" sm="2" md="2" >
                                            <v-btn   x-small color="success" @click="Guardar(3)">
                                                Guardar Gastos Ind.
                                            </v-btn>
                                        </v-col> -->

                                    </v-row>
                                </template>        


                                <template v-slot:[`item.actions`]="{ item }">

                                                <!-- <v-icon
                                                    color="red"
                                                    small
                                                    class="mr-2"
                                                    @click="editItem(item)"
                                                
                                                >
                                                    mdi-pencil
                                                </v-icon> -->

                                                <v-icon
                                                    color="red"
                                                    small
                                                    @click="deleteItem(item,3)"                                           
                                                    class="mx-2" 
                                                >
                                                    mdi-delete
                                                </v-icon>


                                                <v-icon
                                                    color="red"
                                                    small
                                                    @click="historial(item,3)"                                           
                                                    class="mx-2" 
                                                    dense
                                                >
                                                mdi-history
                                                </v-icon> 
                                                

                                </template>



                            </v-data-table>
                        </v-col>
                        
                    </v-row>  
                    
                    <!-- <v-row dense>
                        <v-col cols="4" sm="4" md="4" >
                            <v-btn x-small color="success" @click="agregarFila(3)">
                                Agregar Fila 
                            </v-btn>
                        </v-col>                
                        <v-col cols="4" sm="4" md="4" >
                            <v-btn x-small color="success" @click="Guardar(3)">
                            Guardar GI
                            </v-btn>
                        </v-col>
                    </v-row>   -->

                <!-- </v-card-text>
                </v-card> -->

                </v-form>
        

          </v-tab-item>
          


          <v-tab-item>

                <!-- <v-card color="blue lighten-4" class="py-0 my-0">
           <v-card-text class="py-0 my-0"> -->
         
                <v-form>
                    <v-row dense>
                    <v-col cols="12" sm="12" md="12">
                            <v-data-table
                                :headers="headersMO"
                                :items="moCan ? dessertsMOConCantidades : dessertsMO"                                                
                                class="elevation-1"
                                                                 
                                fixed-header
                                :items-per-page="dessertsMO.length"
                                item-key="name"
                                :search="search2"
                                :custom-filter="filterOnlyCapsText"
                                    dense
                            >  


                                <template v-slot:item.nombre="{ item }"> 
                                        <v-text-field 
                                        v-model="item.nombre"  
                                        dense
                                        
                                    
                                        >
                                        </v-text-field> 
                                </template>
                                                    
                                                            
                                <template v-slot:item.dolar="{ item }">
        
                                    <v-text-field 
                                    v-model="item.dolar"  
                                    dense
                                    
                                    type="number"  

                                        
                                    >
                                    </v-text-field>

                                </template>


                                <template v-slot:item.pesos="{ item }">

                                    <v-text-field 
                                    v-model="item.pesos"  
                                    dense
                                    
                                    type="number"  


                                    >
                                    </v-text-field>

                                </template>


                                <template v-slot:item.idproducto1="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto1"  color="blue">

                                  </v-checkbox>
                                </template>

                                <template v-slot:item.idproducto2="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto2">

                                  </v-checkbox>
                                </template>


                                <template v-slot:item.idproducto3="{ item }"> 
                                  <v-checkbox v-model="item.idproducto3">

                                  </v-checkbox>
                                </template>

                                <template v-slot:item.idproducto4="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto4">

                                  </v-checkbox>
                                </template>


                                <template v-slot:top>
                                    <v-row>
                                        <!-- <v-col cols="2" sm="2" md="2">

                                            <v-toolbar flat dense>
                                                <v-toolbar-title center>
                                                <font color="red" dense>
                                                Mano de Obra
                                                </font>
                                                </v-toolbar-title>
                                
                                            </v-toolbar>


                                        </v-col> -->

                                        <v-col cols="1" sm="1" md="1" >
                                            <v-btn  x-small color="success" @click="activarDialogo(4)">
                                                Agregar Fila
                                            </v-btn>
                                        </v-col>

                                        <!-- <v-col cols="2" sm="2" md="2" >
                                            <v-btn  x-small color="success" @click="Guardar(4)">
                                                Guardar MO
                                            </v-btn>
                                        </v-col> -->

                                        <v-col cols="9" sm="9" md="9">

                                                <v-text-field
                                                    v-model="search2"
                                                    label="Buscar por Nombre"
                                                    class="mx-4"
                                                    @input="convertirAMayusculas(search2,3)"
                                                ></v-text-field>

                                        </v-col>
                                    </v-row>
                                
                                    
                                </template>


                                


                                <template v-slot:[`item.actions`]="{ item }">

                                                <!-- <v-icon
                                                    color="red"
                                                    small
                                                    class="mr-2"
                                                    @click="editItem(item)"
                                                
                                                >
                                                    mdi-pencil
                                                </v-icon> -->

                                                <v-icon
                                                    color="red"
                                                    small
                                                    @click="deleteItem(item,4)"                                           
                                                    class="mx-2" 
                                                >
                                                    mdi-delete
                                                </v-icon>


                                                <v-icon
                                                    color="red"
                                                    small
                                                    @click="historial(item,4)"                                           
                                                    class="mx-2" 
                                                    dense
                                                >
                                                mdi-history
                                                </v-icon> 
                                                

                                </template>


                            </v-data-table>
                        </v-col>
                        
                    </v-row>
                

                <!-- </v-card-text>
                </v-card> -->

                </v-form>   
        

          </v-tab-item>


          <v-tab-item>
            <v-form>
                <v-row dense>
                    <v-col cols="12" sm="12" md="12">
                            <v-data-table

                                :headers="headersDE"
                                :items="mdCan ? dessertsDEConCantidades : dessertsDE"                                                
                                class="elevation-1"
                                                                
                                fixed-header
                                :items-per-page="dessertsDE.length"
                                item-key="name"
                                :search="search4"
                                :custom-filter="filterOnlyCapsText"
                                dense

                            >  


                                <template v-slot:item.nombre="{ item }"> 
                                        <v-text-field 
                                        v-model="item.nombre"  
                                        dense
                                        
                                    
                                        >
                                        </v-text-field> 
                                </template>
                                                    
                                                            
                                <template v-slot:item.dolar="{ item }">

                                    <v-text-field 
                                    v-model="item.dolar"  
                                    dense                                    
                                    type="number"  

                                        
                                    >
                                    </v-text-field>

                                </template>


                                <template v-slot:item.pesos="{ item }">

                                    <v-text-field 
                                    v-model="item.pesos"  
                                    dense                                    
                                    type="number"  


                                    >
                                    </v-text-field>

                                </template>


                                <template v-slot:item.idproducto1="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto1"  color="blue">

                                  </v-checkbox>
                                </template>

                                <template v-slot:item.idproducto2="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto2">

                                  </v-checkbox>
                                </template>


                                <template v-slot:item.idproducto3="{ item }"> 
                                  <v-checkbox v-model="item.idproducto3">

                                  </v-checkbox>
                                </template>

                                <template v-slot:item.idproducto4="{ item }"> 
                                  <v-checkbox  v-model="item.idproducto4">

                                  </v-checkbox>
                                </template>


                                <template v-slot:top>
                                    <v-row>                                       
                                        <v-col cols="1" sm="1" md="1" >
                                            <v-btn  x-small color="success" @click="activarDialogo(6)">
                                                Agregar Fila
                                            </v-btn>
                                        </v-col>                                      

                                        <v-col cols="9" sm="9" md="9">

                                                <v-text-field
                                                    v-model="search4"
                                                    label="Buscar por Nombre"
                                                    class="mx-4"
                                                    @input="convertirAMayusculas(search4,6)"
                                                ></v-text-field>

                                        </v-col>
                                    </v-row>
                                
                                    
                                </template>


                                


                                <template v-slot:[`item.actions`]="{ item }">

                                            
                                                <v-icon
                                                    color="red"
                                                    small
                                                    @click="deleteItem(item,6)"                                           
                                                    class="mx-2" 
                                                >
                                                    mdi-delete
                                                </v-icon>


                                                <v-icon
                                                    color="red"
                                                    small
                                                    @click="historial(item,6)"                                           
                                                    class="mx-2" 
                                                    dense
                                                >
                                                mdi-history
                                                </v-icon> 
                                                

                                </template>


                            </v-data-table>
                    </v-col>
                        
                </v-row>

            </v-form>   


          </v-tab-item>






          <!-- <v-tab-item>

             
                    <v-form>
                        <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                                <v-data-table
                                    :headers="headersMV"
                                    :items="MvCan ? dessertsMVConCantidades : dessertsMV"                                                
                                    class="elevation-1"
                                                                       
                                    fixed-header
                                    :items-per-page="dessertsMV.length"
                                    item-key="name"
                                    :search="search3"
                                    :custom-filter="filterOnlyCapsText"
                                    dense

                                > 
                                
                                    <template v-slot:item.nombre="{ item }"> 
                                                <v-text-field 
                                                v-model="item.nombre"  
                                                dense
                                                
                                            
                                                >
                                                </v-text-field> 
                                    </template>
                                
                                                                
                                    <template v-slot:item.dolar="{ item }">
            
                                            <v-text-field 
                                            v-model="item.dolar"  
                                            dense
                                            type="number"  

                                                
                                            >
                                            </v-text-field>
            
                                    </template>

                                    <template v-slot:item.pesos="{ item }">
            
                                        <v-text-field 
                                        v-model="item.pesos"  
                                        dense
                                        
                                        type="number"  

                                            
                                        >
                                        </v-text-field>

                                    </template>


                                    <template v-slot:top>
                                        <v-row>

                                    

                                            <v-col cols="1" sm="1" md="1" >
                                                <v-btn  x-small color="success" @click="activarDialogo(5)">
                                                    Agregar Fila
                                                </v-btn>
                                            </v-col>

                                        

                                            <v-col cols="9" sm="9" md="9">
                                                
                                                    <v-text-field
                                                        v-model="search3"
                                                        label="Buscar por Nombre"
                                                        class="mx-4"
                                                        @input="convertirAMayusculas(search3,5)"
                                                    ></v-text-field>                                   

                                            </v-col>

                                        </v-row>
                                    
                                        
                                    </template>



                                    <template v-slot:[`item.actions`]="{ item }">

                                                
                                                    <v-icon
                                                        color="red"
                                                        small
                                                        @click="deleteItem(item,5)"                                           
                                                        class="mx-2" 
                                                    >
                                                        mdi-delete
                                                    </v-icon>


                                                    <v-icon
                                                        color="red"
                                                        small
                                                        @click="historial(item,5)"                                           
                                                        class="mx-2" 
                                                    >
                                                        mdi-history
                                                    </v-icon>
                                
                                                    

                                    </template>
            
                                    
                                </v-data-table>
                            </v-col>
                            
                        </v-row>
                                    
                   
                    </v-form>  


          </v-tab-item>       -->
          
          


         
          
        </v-tabs>  




         
         
         
         

 
        
        
        <v-spacer></v-spacer>

        <v-spacer></v-spacer>

        <v-spacer></v-spacer>




         


         <v-dialog v-model="dialogAlta" persistent  max-width="800px" > 
            <v-card class="mb-3 pa-3">
                <v-card-title class="headline layout justify-center red--text">
                    <h5>  {{vTitulo}} </h5> 
                </v-card-title>
                <v-row>
                    <v-col>

                        <v-text-field v-model="vNombre" dense label="Nombre">

                        </v-text-field>
                    </v-col>
                </v-row>    
                <v-row>
                    <v-col cols="6" sm="6" md="6">

                        <v-text-field v-model="mDolar"  type="number"   dense label="Dolar">

                        </v-text-field>

                    </v-col>
                    <v-col  cols="6" sm="6" md="6" >

                        <v-text-field v-model="mPesos"  type="number"   dense label="Pesos">

                        </v-text-field>

                    </v-col>
                </v-row>    
                
                
                <v-row>
                        <v-col cols="6" sm="6" md="6">
                            <v-btn @click="agregarFila1(tipoTaller)">
                                Agregar Material
                            </v-btn>
                        </v-col>    
                        <v-col cols="6" sm="6" md="6">
                            <v-btn @click="dialogAlta=false">
                                Salir
                            </v-btn>
                        </v-col>    
                </v-row>   
                

            </v-card>    
        </v-dialog> 
        
        

        <v-dialog
            v-model="showLoadingAlert"
            max-width="170"
            >
            <v-card>

                <v-card-title class="text-h5">
                Aguarde....
                </v-card-title>

                <!-- <v-card-text>
                Aguarde....
                </v-card-text> -->

            
            </v-card>
        </v-dialog>

        <v-dialog 
            v-if="dialogHistorial"  
            max-width="800"
            persistent
            v-model="dialogHistorial"
            
        >

            <v-card >
                <v-card-title>
                    <v-row>
                        <v-col cols="10" sm="10" md="10">
                            <h3 class="red--text">   {{ showCodigo }}  -  {{ showMaterial }}</h3>

                        </v-col>                                
                    </v-row>   
                </v-card-title>
                <v-card-text class="py-0 my-0">
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                            
                                <v-data-table
                                    :headers="headersHis"
                                    :items="dessertHis"                                                
                                    class="elevation-1"
                                    height="400"                                   
                                    fixed-header
                                    :items-per-page="dessertHis.length"
                                    dense
                                    
                                >                        
                                                                
                        
                                </v-data-table>
                            </v-col>

            
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-btn block color="success" @click="dialogHistorial=false">
                                    Salir
                                </v-btn>   
                            </v-col>    
                        </v-row>                  
		        </v-card-text>  
            </v-card>               

        </v-dialog>



        <v-dialog v-if="dialogPrecio" max-width="1200" persistent v-model="dialogPrecio">
            <v-card>
                <v-card-title>
                    <v-row>
                    <v-col cols="10" sm="10" md="10">
                        <h3>Ajuste de Precios</h3>
                    </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="py-0 my-0">
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-radio-group v-model="selectedOption">
                                <v-radio label="Ajuste de precio por categoría" value="category"></v-radio>
                                <v-radio label="Ajuste general de precio" value="general"></v-radio>
                            </v-radio-group>
                            <v-row v-if="selectedOption === 'category'">
                                <v-col cols="6">
                                    <v-select
                                    v-model="selectedCategory"
                                    :items="categories"
                                    label="Selecciona una categoría"
                                    dense
                                    ></v-select>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                    v-model="categoryPercentage"
                                    label="Porcentaje de aumento"
                                    type="number"
                                    dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row v-if="selectedOption === 'general'">
                                <v-col cols="12">
                                    <v-text-field
                                    v-model="generalPercentage"
                                    label="Porcentaje de aumento general"
                                    type="number"
                                    dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-btn block color="success" @click="applyPriceAdjustment()">
                            Aplicar
                            </v-btn>
                        </v-col>
                        <v-col>
                            <v-btn block color="error" @click="dialogPrecio = false">
                            Salir
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        
    </div> 

        
       





        

 
       <!-- </v-form>
     </v-app>
   </div>           -->
             
 </template>
 
 <script>
 import Axios from "../../../axios-auth-sistemas";
 import moment from "moment";
 
 export default {
     name:'Plantilla',
     data(){
        return{
         
         vTitulo:"",
         vVar:0,
         mDolar:0,
         mPesos:0,    
         dialogAlta: false,

         dialogHistorial: false,
         showMaterial:'',   
         showCodigo:'', 
         
         
         dialogPrecio: false,
         selectedOption: null,
         categories: ["Taller", "Tercero", "Gastos Indirecto", "Mano Obra", "Deposito"],
         selectedCategory: null,
         categoryPercentage: null,
         generalPercentage: null,
   


         tipoTaller:0,   
         matTaller:['Chapa', 'Materiales'],
         
         headersHis:
            [
                    {text: 'Fecha',value: 'fecha',width:"25%", align: "left",sortable: false,  },    
                    {text: 'Dolar',value: 'dolar',width:"25%", align: "left",sortable: false,   },
                    {text: 'Pesos',value: 'pesos', width:"25%",  align: "left",sortable: false  }, 
                    
            ],
         


         headers:
            [
                    {text: 'Código',value: 'codigoMate',width:"10%", align: "left",sortable: false, style: 'font-weight: bold; color: blue; background-color: #ffffcc;' },    
                    {text: 'MATERIALES DE TALLER',value: 'nombre',width:"50%", align: "left",sortable: false,  class: 'font-weight: bold; color: blue; background-color: #ffffcc;' },
                    {text: 'Dolar',value: 'dolar', width:"15%",  align: "left",sortable: false  }, 
                    {text: 'Pesos',value: 'pesos' , width:"15%",  align: "left",sortable: false },   

                    {text: 'Celdas',value: 'idproducto1' ,  align: "left",sortable: false }, 
                    {text: 'Centro Compacto',value: 'idproducto2' ,  align: "left",sortable: false },   
                    {text: 'Secc.',value: 'idproducto3' ,  align: "left",sortable: false },   
                    {text: 'Tableros BT',value: 'idproducto4',  align: "left",sortable: false }, 



                    // {text: 'Celdas',value: 'idproducto1A' , width:"20%",  align: "left",sortable: false }, 
                    // {text: 'Centro Compacto',value: 'idproducto2A' , width:"20%",  align: "left",sortable: false },   
                    // {text: 'Seccionadores',value: 'idproducto3A' , width:"20%",  align: "left",sortable: false },   
                    // {text: 'Tableros BT',value: 'idproducto4A' , width:"20%",  align: "left",sortable: false }, 


                    {text: 'Fecha',value: 'fecha1' , width:"20%",  align: "left",sortable: false },                    
                    { text: 'Acciones', value: 'actions', width:"10%", sortable: false ,  align: "center",sortable: false  },

                   // {text: 'Fecha',value: 'fecha' , width:"20%",  align: "left",sortable: false },

                    // {text: 'id.',value: 'id' , width:"20%",  align: "left",sortable: false },   
                    // {text: 'D',value: 'dolarA', width:"20%",  align: "left",sortable: false  }, 
                    // {text: 'P',value: 'pesosA' , width:"20%",  align: "left",sortable: false }, 
                    // {text: 'Taller',value: 'taller' , width:"20%",  align: "left",sortable: false },
                   //  {text: 'id',value: 'id1' , width:"20%",  align: "left",sortable: false },     

            ],


            headersTerc:
            [
                    {text: 'Código',value: 'codigoMate',width:"10%", align: "left",sortable: false, style: 'font-weight: bold; color: blue; background-color: #ffffcc;'},
                    {text: 'ELEM. Y SERV. TERCERIZADOS',value: 'nombre', width:"50%", align: "left",sortable: false, style: 'font-weight: bold; color: blue; background-color: #ffffcc;'  },
                    {text: 'Dolar.',value: 'dolar' ,width:"15%" , align: "left",sortable: false  }, 
                    {text: 'Pesos.',value: 'pesos' ,width:"15%" ,   align: "left",sortable: false },

                    {text: 'Celdas',value: 'idproducto1' ,  align: "left",sortable: false }, 
                    {text: 'Centro Compacto',value: 'idproducto2' ,   align: "left",sortable: false },   
                    {text: 'Secc.',value: 'idproducto3' ,   align: "left",sortable: false },   
                    {text: 'Tableros BT',value: 'idproducto4' ,  align: "left",sortable: false }, 

                    {text: 'Fecha',value: 'fecha1' ,width:"20%" ,   align: "left",sortable: false },                                            
                    { text: 'Acciones', value: 'actions', width:"10%", sortable: false ,  align: "center",sortable: false  },
                  //  {text: 'Fecha',value: 'fecha' , width:"20%",  align: "left",sortable: false },

                    // {text: 'id.',value: 'id' , width:"20%",  align: "left",sortable: false }, 
                    // {text: 'id',value: 'id1' , width:"20%",  align: "left",sortable: false },   
            ],

            headersGI:
            [
            {text: 'Código',value: 'codigoMate',width:"10%", align: "left",sortable: false, style: 'font-weight: bold; color: blue; background-color: #ffffcc;'},
                    {text: 'GASTOS INDIRECTOS TALLER',value: 'nombre',width:"40%", align: "left",sortable: false,  style: 'font-weight: bold; color: blue; background-color: #ffffcc;'  },
                    {text: 'Dolar.',value: 'dolar',  align: "left",width:"20%",sortable: false  }, 
                    {text: 'Pesos.',value: 'pesos' ,  align: "left",width:"20%",sortable: false },   
                    { text: 'Acciones', value: 'actions', sortable: false ,width: "10%",  align: "center",sortable: false  },

                    // {text: 'id.',value: 'id' , width:"20%",  align: "left",sortable: false },   
                    // {text: 'id',value: 'id1' , width:"20%",  align: "left",sortable: false }, 
            ],

            headersMO:
            [

                    {text: 'Código',value: 'codigoMate',width:"10%", align: "left",sortable: false, style: 'font-weight: bold; color: blue; background-color: #ffffcc;'},
                    {text: 'MANO DE OBRA P/PRODUCCIÓN',value: 'nombre',width:"50%", align: "left",sortable: false,  style: 'font-weight: bold; color: blue; background-color: #ffffcc;'  },
                    {text: 'Dolar.',value: 'dolar', width:"15%", align: "left",sortable: false  }, 
                    {text: 'Pesos.',value: 'pesos' , width:"15%",  align: "left",sortable: false },  
                    
                    {text: 'Celdas',value: 'idproducto1' ,   align: "left",sortable: false }, 
                    {text: 'Centro Compacto',value: 'idproducto2' ,   align: "left",sortable: false },   
                    {text: 'Secc.',value: 'idproducto3' ,   align: "left",sortable: false },   
                    {text: 'Tableros BT',value: 'idproducto4' ,   align: "left",sortable: false }, 
                    
                    {text: 'Fecha',value: 'fecha1' , width:"20%",  align: "left",sortable: false },                        
                    { text: 'Acciones', value: 'actions', width:"10%", sortable: false ,  align: "center",sortable: false  },
                    //{text: 'Fecha',value: 'fecha' , width:"20%",  align: "left",sortable: false },

                    // {text: 'id.',value: 'id' , width:"20%",  align: "left",sortable: false },   
                    // {text: 'id',value: 'id1' , width:"20%",  align: "left",sortable: false }, 
            ],

            // headersMV:
            // [

            //         {text: 'Código',value: 'codigoMate',width:"10%", align: "left",sortable: false, style: 'font-weight: bold; color: blue; background-color: #ffffcc;'},
            //         {text: 'MATERIALES VARIOS',value: 'nombre',width:"40%", align: "left",sortable: false,  style: 'font-weight: bold; color: blue; background-color: #ffffcc;'  },
            //         {text: 'Dolar.',value: 'dolar', width:"20%", align: "left",sortable: false  }, 
            //         {text: 'Pesos.',value: 'pesos' , width:"20%",  align: "left",sortable: false },   
            //         { text: 'Acciones', value: 'actions', sortable: false ,width: "10%",  align: "center",sortable: false  },
            //         // {text: 'id.',value: 'id' , width:"20%",  align: "left",sortable: false },   
            //         // {text: 'id',value: 'id1' , width:"20%",  align: "left",sortable: false }, 
            //        // {text: 'codigo.',value: 'codigoMate' , width:"20%",  align: "left",sortable: false },    
            // ],


            headersDE:
            [

                    {text: 'Código',value: 'codigoMate',width:"10%", align: "left",sortable: false, style: 'font-weight: bold; color: blue; background-color: #ffffcc;'},
                    {text: 'PROVISIÓN DE DEPOSITO',value: 'nombre',width:"50%", align: "left",sortable: false,  style: 'font-weight: bold; color: blue; background-color: #ffffcc;'  },
                    {text: 'Dolar.',value: 'dolar', width:"15%", align: "left",sortable: false  }, 
                    {text: 'Pesos.',value: 'pesos' , width:"15%",  align: "left",sortable: false },   

                    {text: 'Celdas',value: 'idproducto1' ,  align: "left",sortable: false }, 
                    {text: 'Centro Compacto',value: 'idproducto2' ,   align: "left",sortable: false },   
                    {text: 'Secc.',value: 'idproducto3' ,  align: "left",sortable: false },   
                    {text: 'Tableros BT',value: 'idproducto4' ,  align: "left",sortable: false }, 


                    {text: 'Fecha',value: 'fecha1' , width:"20%",  align: "left",sortable: false },                        
                    { text: 'Acciones', value: 'actions', width:"10%", sortable: false ,  align: "center",sortable: false  },


                 //   {text: 'Fecha',value: 'fecha' , width:"20%",  align: "left",sortable: false },
                    
                    // {text: 'id.',value: 'id' , width:"20%",  align: "left",sortable: false },   
                    // {text: 'id',value: 'id1' , width:"20%",  align: "left",sortable: false }, 
                   // {text: 'codigo.',value: 'codigoMate' , width:"20%",  align: "left",sortable: false },    



                //    {text: 'Celdas',value: 'idproducto1A' ,  align: "left",sortable: false }, 
                //     {text: 'Centro Compacto',value: 'idproducto2A' ,   align: "left",sortable: false },   
                //     {text: 'Secc.',value: 'idproducto3A' ,  align: "left",sortable: false },   
                //     {text: 'Tableros BT',value: 'idproducto4A' ,  align: "left",sortable: false }, 

            ],

           


              
         desserts: [], 
         dessertsTer: [],
         dessertsMO: [],
         dessertsGI:[],
         dessertsMV:[],
         dessertsDE: [],


         dessertsOriginal: [], 
         dessertsTerOriginal: [],
         dessertsMOOriginal: [],
         dessertsGIOriginal:[],
         dessertsMVOriginal:[],
         dessertsDEOriginal: [],   


         dessertBorrar:[],


         dessertHis:[],   
 
         valid: false,
         lazy: false,
 
         totalpSum:0,
         totaldSum:0,
         totalpSum1:0,
         totaldSum1:0,
         totalpSum2:0,
         totaldSum2:0,
         totalpSum3:0,
         totaldSum3:0,   

         totalpSum4:0,
         totaldSum4:0,   
 
         cantTaller:0,
         totalTercero:0,
         totalTaller:0,
 
         mtCan:false,
         mtsCan:false,
         terCan:false,
         tersCan:false,
         moCan:false,
         mosCan:false,
         MvCan:false,
         MvsCan:false,
         mdCan:false,
         mdsCan:false,
 
 
         filtro:0,
         filtroTer:0,
         filtroMO:0,
         filtroMV:0,
         filtroDE:0,
 
 
         item1: {
             cantidad: 0, // Valor predeterminado u otro valor según tus necesidades
             totalp: null,
             totald: null,
             // Otras propiedades necesarias
         },
 
 
         item: {
             cantidad: 0, // Valor predeterminado u otro valor según tus necesidades
             totalp: null,
             totald: null,
             // Otras propiedades necesarias
         },
      
 
 
         vCodigo:'',
         vNombre:'',
         vDolar:0,
 
         search: '',
         search1:'',
         search2:'',
         search3:'',
         search4:'',

         editedIndex: -1,


         showLoadingAlert:false,

         idproducto1:false,
         idproducto2:false,
         idproducto3:false,
         idproducto4:false,


         tildados: [],
         destildados:[],



        }
     },
     watch: {
 
 
         pesosAdmGI(newValue)
         {
             console.log("estioy en watched cantidadGI")
             // Cuando cantidadGI cambie, actualiza el valor en headersGI
             const idTaller = 3; // ID del taller que deseas actualizar
             console.log( this.dessertsGI)
             const indice = this.dessertsGI.findIndex((element, index) => element.taller === idTaller);
             //this.headersGI.findIndex((item) => item.taller == idTaller);
             console.log(newValue)
             if (indice !== -1) {
                 console.log("pasooooooooooo")
                 if(this.vDolar !=0 && this.vDolar != null && this.vDolar != '' )
                 {
                   
                     let vDolA = (parseFloat(newValue) * parseFloat(this.vDolar));
                     console.log(vDolA);
                     this.dessertsGI[indice].cantidad = vDolA.toFixed(2);
 
                     //this.dessertsGI[indice].cantidad = (newValue * this.vDolar).toFixed(2);
                 }
                 else
                 {
                     this.dessertsGI[indice].cantidad = newValue.toFixed(2);
                 }
                 
                 if (this.dessertsGI[indice].pesos != "" && this.dessertsGI[indice].pesos != null)
                 {
                     this.dessertsGI[indice].totalp = (this.dessertsGI[indice].pesos * this.dessertsGI[indice].cantidad).toFixed(2);
                 }
 
 
                 if (this.dessertsGI[indice].dolar != "" && this.dessertsGI[indice].dolar != null)
                 {
                     this.dessertsGI[indice].totald = (this.dessertsGI[indice].dolar * this.dessertsGI[indice].cantidad).toFixed(2);
                 }
 
             }
         },
 
 
         
         totalTallerCantidad(newValue) 
         {
 
             console.log("estioy en watched totalTallerCantidad")
             // Cuando cantidadGI cambie, actualiza el valor en headersGI
             const idTaller = 33; // ID del taller que deseas actualizar
             console.log( this.dessertsGI)
             const indice = this.dessertsGI.findIndex((element, index) => element.taller === idTaller);
             //this.headersGI.findIndex((item) => item.taller == idTaller);
             console.log(indice)
             if (indice !== -1) {
                 console.log("pasooooooooooo")
                 this.dessertsGI[indice].cantidad = newValue.toFixed(2);
                 if (this.dessertsGI[indice].pesos != "" && this.dessertsGI[indice].pesos != null)
                 {
                     this.dessertsGI[indice].totalp = (this.dessertsGI[indice].pesos * this.dessertsGI[indice].cantidad).toFixed(2);
                 }
 
 
                 if (this.dessertsGI[indice].dolar != "" && this.dessertsGI[indice].dolar != null)
                 {
                     this.dessertsGI[indice].totald = (this.dessertsGI[indice].dolar * this.dessertsGI[indice].cantidad).toFixed(2);
                 }
 
             }
 
         },
 
 
         
     },    
     computed: {
         show: {
             get() {
                // this.cargar_Plantilla();
                
             },
             set(value) {
                 if (!value) {
                 }
             },
         },
         dessertsConCantidades() {
             // Filtra tus datos para mostrar solo filas con cantidades si verFilasConCantidades es true
             return this.desserts.filter((item) => item.cantidad > 0);
         },
         dessertsTerConCantidades() {
             // Filtra tus datos para mostrar solo filas con cantidades si verFilasConCantidades es true
             return this.dessertsTer.filter((item) => item.cantidad > 0);
         },
         dessertsMOConCantidades() {
             // Filtra tus datos para mostrar solo filas con cantidades si verFilasConCantidades es true
             return this.dessertsMO.filter((item) => item.cantidad > 0);
         },

        //  dessertsMVConCantidades() {
        //      // Filtra tus datos para mostrar solo filas con cantidades si verFilasConCantidades es true
        //      return this.dessertsMV.filter((item) => item.cantidad > 0);
        //  },

         dessertsDEConCantidades() {
             // Filtra tus datos para mostrar solo filas con cantidades si verFilasConCantidades es true
             return this.dessertsDE.filter((item) => item.cantidad > 0);
         },
         totalTallerCantidad() {
             return this.desserts.reduce((cantTaller, dessert) => {
                 if (dessert.taller === 1) {
                     return cantTaller + parseFloat(dessert.cantidad || 0);
                 }
 
                 return cantTaller  ;
                 }, 0);
         },
         cantidadGI(){
             return this.totalTallerCantidad + this.totaldSum;
         },
         totalTerceroDolar(){
             return this.dessertsTer.reduce((totalTercero, dessertsTer) => {
                 
                     return totalTercero + parseFloat(dessertsTer.totald || 0);
                 
 
             
                 }, 0);
         },
         totalTallerDolar() {
             return this.desserts.reduce((totalTaller, dessert) => {
                 if (dessert.taller === 2) {
                     return totalTaller + parseFloat(dessert.totald || 0);
                 }
 
                 return totalTaller  ;
                 }, 0);
         },
         pesosAdmGI(){
             return this.totalTallerDolar + this.totalTerceroDolar;
          // return this.vDolar == null || this.vDolar =="" || this.vDolar == 0 ? this.totalTallerDolar + this.totalTerceroDolar : (this.totalTallerDolar + this.totalTerceroDolar)*this.Vdolar;  
 
         },
 
        
     },

     mounted() {

        this.tildados = [];
        this.destildados = [];

        this.cargar_Plantilla();
        

     },
     methods: {


     
        ajuste()
        {

            this.dialogPrecio=true;

        },

        historial(item)
        {

                        
                        this.showMaterial = "";
                        this.showCodigo = ""; 
                        this.dessertHis = [];
                            
                        console.log(item);
                        Axios
                        .get("/Plantilla/GetHistorialMaterial?", {
                        params: {
                            id: item.codigoMate,
                        },
                        })
                        
                        .then((r) => {             
                            
                            console.log(r.data);
                            this.dialogHistorial = true;
                            this.showMaterial = item.nombre;
                            this.showCodigo = item.codigoMate; 
                           

                            r.data.forEach(element => {
                                    this.dessertHis.push({

                                        fecha: moment(element.fecha).format("DD/MM/YYYY"),
                                        dolar :element.dolar == null ? 0   : element.dolar,
                                        pesos: element.pesos == null ? 0   : element.pesos,
                                       



                                    })
                        });
                            
                                
                        })
                        .catch((error) => {
                            console.log("error no pasa en el historial")                  
                        }); 
                 

        },

        activarDialogo(tipo)
        {
            this.dialogAlta =true;

            console.log(tipo);



            this.vTitulo ="";
            this.tipoTaller =0;
            this.vNombre="";
            this.mDolar = 0,
            this.mPesos = 0,  

            console.log(tipo)
            if(tipo == 11)
            {
                this.vTitulo ="Materiales de Chapa";               
                this.tipoTaller= tipo;

              


            }


            if(tipo == 22)
            {
                this.vTitulo ="Materiales";              
                this.tipoTaller= tipo;

               


            }


            if(tipo == 2)
            {
                this.vTitulo ="Servicios Tericarizados";               
                this.tipoTaller= tipo;

             

            }
            if(tipo == 3)
            {
                this.vTitulo ="Gastos Indirectos";               
                this.tipoTaller= tipo;

              


            }   
            if(tipo == 4)
            {
                this.vTitulo ="Mano de Obra";               
                this.tipoTaller= tipo;

               

            }
            if(tipo == 5)
            {
                this.vTitulo ="Materiales Varios";               
                this.tipoTaller= tipo;

                


            }
            if(tipo == 6)
            {
                this.vTitulo ="Provisión de Deposito";               
                this.tipoTaller= tipo;

                


            }


            
            


        },


        agregarFila1(tipo)
        {
            

            console.log("estoy en agregarFila1");
            console.log(tipo)
            if(tipo == 11)
            {
                           
                this.tipoTaller= tipo;

                const nuevaFila = {
                    codigoMate: tipo == 11 ? 'Chapa' : 'Materiales',
                    nombre: this.vNombre,
                    pesos: this.mPesos,
                    dolar: this.mDolar,
                    id1: 0
                };

                this.desserts.push(nuevaFila); // Cambiado a push
                this.nuevaFila = nuevaFila;


            }


            if(tipo == 22)
            {
                          
                this.tipoTaller= tipo;

                const nuevaFila = {
                    codigoMate: tipo == 11 ? 'Chapa' : 'Materiales',
                    nombre: this.vNombre,
                    pesos: this.mPesos,
                    dolar: this.mDolar,
                    id1: 0
                };

                this.desserts.push(nuevaFila); // Cambiado a push
                this.nuevaFila = nuevaFila;


            }


            if(tipo == 2)
            {
                             
                this.tipoTaller= tipo;

                const nuevaFila = {
                    codigoMate: "",
                    nombre: this.vNombre,
                    pesos: this.mPesos,
                    dolar: this.mDolar,
                    id1: 0
                };

                this.dessertsTer.push(nuevaFila); // Cambiado a push
                this.nuevaFila = nuevaFila;


            }
            if(tipo == 3)
            {
                          
                this.tipoTaller= tipo;

                const nuevaFila = {
                    codigoMate: "",
                    nombre: this.vNombre,
                    pesos: this.mPesos,
                    dolar: this.mDolar,
                    id1: 0
                };

                this.dessertsGI.push(nuevaFila); // Cambiado a push
                this.nuevaFila = nuevaFila;


            }   
            if(tipo == 4)
            {
                            
                this.tipoTaller= tipo;

                const nuevaFila = {
                    codigoMate: "",
                    nombre: this.vNombre,
                    pesos: this.mPesos,
                    dolar: this.mDolar,
                    id1: 0
                };

                this.dessertsMO.push(nuevaFila); // Cambiado a push
                this.nuevaFila = nuevaFila;


            }

            // if(tipo == 5)
            // {
            //     this.vTitulo ="Materiales Varios";               
               

            //     const nuevaFila = {
            //         codigoMate: "",
            //         nombre: this.vNombre,
            //         pesos: this.mPesos,
            //         dolar: this.mDolar,
            //         id1: 0
            //     };

            //     this.dessertsMV.push(nuevaFila); // Cambiado a push
            //     this.nuevaFila = nuevaFila;


            // }

            if(tipo == 6)
            {
                this.vTitulo ="Provision de Deposito";               
               

                const nuevaFila = {
                    codigoMate: "",
                    nombre: this.vNombre,
                    pesos: this.mPesos,
                    dolar: this.mDolar,
                    id1: 0
                };

                this.dessertsDE.push(nuevaFila); // Cambiado a push
                this.nuevaFila = nuevaFila;


            }



            this.dialogAlta = false;
            


        },


        copiar_Array()
        {   
            console.log("copiar_Array");
           
            this.desserts1 = [...this.desserts];
            console.log("desserts1");
            console.log(this.desserts1)
           
            
          
           
        },
 
         cargar_Plantilla()
         {
                 console.log("estoy en cargar plantilla")
                 
               

                 let self = this;   

                 self.dessertBorrar=[];
                 self.desserts = [];
                 self.dessertsGI = [];
                 self.dessertsMO = [];
                // self.dessertsMV = [];
                 self.dessertsTer = [];
                 self.dessertsDE = [];

                 /*TALLER*/
                 Axios
                 .get("/Plantilla/GetPlantillaNuevo?", {
                 params: {
                     id: '1',
                 },
                 })
                 
                 .then((r) => {             
                     
                     
                    console.log(r.data)

                    r.data.forEach(element => {
                        

                        this.desserts.push({
                            codigoMate: element.codigoMate,
                            nombre: element.nombre,
                            dolar: element.dolar,
                            pesos: element.pesos,
                            id: element.id,
                            dolarA: element.dolar,
                            pesosA: element.pesos,
                            taller: element.taller,
                            id1: element.id1,
                            fecha: moment(element.fecha, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
                            fecha1: element.fecha.split(' ')[0],
                            idproducto1: element.celda == '1' ? true : false,
                            idproducto2: element.cc == '1' ? true : false,
                            idproducto3: element.secc == '1' ? true : false,
                            idproducto4: element.tablero == '1' ? true : false,
                            idproducto1A: element.celda == '1' ? true : false,
                            idproducto2A: element.cc == '1' ? true : false,
                            idproducto3A: element.secc == '1' ? true : false,
                            idproducto4A: element.tablero == '1' ? true : false,




                        })




                      
                  


                    });
                    
                

                    console.log(" estoy en copiarDatosArray..")

                  //  this.dessertsOriginal = [...this.desserts];


                  this.dessertsOriginal = JSON.parse(JSON.stringify(this.desserts));

                    console.log("mounted original...",this.desserts);

                  //  this.dessertsOriginal = JSON.parse(JSON.stringify(this.desserts)); 
                    

                    console.log("mounted copia..", this.dessertsOriginal);
                   

                    
                   
                        
                 })
                 .catch((error) => {
                     console.log("error no pasa taller")                  
                 }); 
                 
 
                
                             
              
 
                 /*TERCEROS*/
                 Axios
                 .get("/Plantilla/GetPlantillaNuevo?", {
                 params: {
                     id: '2',
                 },
                 })
                 
                 .then((r) => {             
                     
                   
                   // this.dessertsTer = r.data;

                   r.data.forEach(element => {
                        

                        this.dessertsTer.push({
                            codigoMate: element.codigoMate,
                            nombre: element.nombre,
                            dolar: element.dolar,
                            pesos: element.pesos,
                            id: element.id,
                            dolarA: element.dolar,
                            pesosA: element.pesos,
                            taller: element.taller,
                            id1: element.id1,
                            fecha: moment(element.fecha, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
                            fecha1: element.fecha.split(' ')[0],
                            idproducto1: element.celda == '1' ? true : false,
                            idproducto2: element.cc == '1' ? true : false,
                            idproducto3: element.secc == '1' ? true : false,
                            idproducto4: element.tablero == '1' ? true : false,
                            idproducto1A: element.celda == '1' ? true : false,
                            idproducto2A: element.cc == '1' ? true : false,
                            idproducto3A: element.secc == '1' ? true : false,
                            idproducto4A: element.tablero == '1' ? true : false,



                        })


                    });

                        
                 })
                 .catch((error) => {
                     console.log("error no pasa terceros")                  
                 }); 
 
 
              
 
                   /*GI*/
                   Axios
                 .get("/Plantilla/GetPlantilla?", {
                 params: {
                     id: '3',
                 },
                 })
                 
                 .then((r) => {             
                     
                   
                    //this.dessertsGI = r.data;

                    r.data.forEach(element => {
                        

                        this.dessertsGI.push({
                            codigoMate: element.codigoMate,
                            nombre: element.nombre,
                            dolar: element.dolar,
                            pesos: element.pesos,
                            id: element.id,
                            dolarA: element.dolar,
                            pesosA: element.pesos,
                            taller: element.taller,
                            id1: element.id1,
                            fecha: moment(element.fecha, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
                            fecha1: element.fecha.split(' ')[0],


                        })


                    });
 
                  
                        
                 })
                 .catch((error) => {
                     console.log("error no pasa gi")                  
                 }); 



 
                
                 /*MO*/
                 Axios
                 .get("/Plantilla/GetPlantillaNuevo?", {
                 params: {
                     id: '4',
                 },
                 })
                 
                 .then((r) => {             
                     
                  
                   // this.dessertsMO = r.data;

                   r.data.forEach(element => {
                        

                        this.dessertsMO.push({
                            codigoMate: element.codigoMate,
                            nombre: element.nombre,
                            dolar: element.dolar,
                            pesos: element.pesos,
                            id: element.id,
                            dolarA: element.dolar,
                            pesosA: element.pesos,
                            taller: element.taller,
                            id1: element.id1,
                            fecha: moment(element.fecha, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
                            fecha1: element.fecha.split(' ')[0],
                            idproducto1: element.celda == '1' ? true : false,
                            idproducto2: element.cc == '1' ? true : false,
                            idproducto3: element.secc == '1' ? true : false,
                            idproducto4: element.tablero == '1' ? true : false,
                            idproducto1A: element.celda == '1' ? true : false,
                            idproducto2A: element.cc == '1' ? true : false,
                            idproducto3A: element.secc == '1' ? true : false,
                            idproducto4A: element.tablero == '1' ? true : false,



                        })


                    });


                        
                 })
                 .catch((error) => {
                     console.log("error no pasa mo")                  
                 });              



                /*DE*/
                Axios
                 .get("/Plantilla/GetPlantillaNuevo?", {
                 params: {
                     id: '6',
                 },
                 })
                 
                 .then((r) => {             
                     
                         console.log("datos del deposito", r.data)
                 

                    r.data.forEach(element => {
                        

                        this.dessertsDE.push({
                            codigoMate: element.codigoMate,
                            nombre: element.nombre,
                            dolar: element.dolar,
                            pesos: element.pesos,
                            id: element.id,
                            dolarA: element.dolar,
                            pesosA: element.pesos,
                            taller: element.taller,
                            id1: element.id1,
                            fecha: moment(element.fecha, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
                            fecha1: element.fecha.split(' ')[0],
                            idproducto1: element.celda == '1' ? true : false,
                            idproducto2: element.cc == '1' ? true : false,
                            idproducto3: element.secc == '1' ? true : false,
                            idproducto4: element.tablero == '1' ? true : false,
                            idproducto1A: element.celda == '1' ? true : false,
                            idproducto2A: element.cc == '1' ? true : false,
                            idproducto3A: element.secc == '1' ? true : false,
                            idproducto4A: element.tablero == '1' ? true : false,



                        })


                    }); 
                    
                    
                    
                 })
                 .catch((error) => {
                     console.log("error no pasa mv")                  
                 });
 
 
 
         },


         filterOnlyCapsText (value, search, item) {
                return value != null &&
                search != null &&
                typeof value === 'string' &&
                value.toString().toLocaleUpperCase().indexOf(search) !== -1
          },
 
 
         calcularTotales(item, tipo)
         {
             console.log(item)
 
             if (tipo == 'T')
             {
 
                 const cantidad = parseFloat(item.cantidad);
                 if (!isNaN(cantidad)) 
                 {
                     item.cantidad = cantidad; // Asegura que el valor sea numérico
                     if (!isNaN(item.peso)) 
                     {
                         item.totalp = (cantidad * item.pesos).toFixed(2);
                     }
                     if (!isNaN(item.dolar)) 
                     {
                         item.totald = (cantidad * item.dolar).toFixed(2);
                     }
 
                     
                     this.actualizarTotales('T');
                 } 
                 else 
                 {
             
                     item.totalp = null;
                     item.totald = null;
 
                     this.actualizarTotales('T')
             
                 }
 
             }
 
 
             if (tipo == 'Ter')
             {
                 console.log("paso")
                 const cantidad1 = parseFloat(item.cantidad);
                 console.log(parseFloat(item.cantidad))
                 if (!isNaN(cantidad1)) 
                 {
                     item.cantidad = cantidad1; // Asegura que el valor sea numérico
                     if (!isNaN(item.peso)) 
                     {
                         item.totalp = (cantidad1 * item.pesos).toFixed(2);
                     }
                     if (!isNaN(item.dolar)) 
                     {
                         item.totald = (cantidad1 * item.dolar).toFixed(2);
                     }
 
 
                     this.actualizarTotales('Ter');
                 } 
                 else 
                 {
             
                     item.totalp = null;
                     item.totald = null;
 
                     this.actualizarTotales('Ter')
             
                 }
 
             }
            
 
 
             if (tipo == 'MO')
             {
 
                 const cantidad2 = parseFloat(item.cantidad);
                 if (!isNaN(cantidad2)) 
                 {
                     item.cantidad = cantidad2; // Asegura que el valor sea numérico
                     if (!isNaN(item.peso)) 
                     {
                         item.totalp = (cantidad2 * item.pesos).toFixed(2);
                     }
                     if (!isNaN(item.dolar)) 
                     {
                         item.totald = (cantidad2 * item.dolar).toFixed(2);
                     }
 
                     
                     this.actualizarTotales('MO');
                 } 
                 else 
                 {
             
                     item.totalp = null;
                     item.totald = null;
 
                     this.actualizarTotales('MO')
             
                 }
 
             }


             if (tipo == 'MV')
             {
 
                 const cantidad2 = parseFloat(item.cantidad);
                 if (!isNaN(cantidad2)) 
                 {
                     item.cantidad = cantidad2; // Asegura que el valor sea numérico
                     if (!isNaN(item.peso)) 
                     {
                         item.totalp = (cantidad2 * item.pesos).toFixed(2);
                     }
                     if (!isNaN(item.dolar)) 
                     {
                         item.totald = (cantidad2 * item.dolar).toFixed(2);
                     }
 
                     
                     this.actualizarTotales('MV');
                 } 
                 else 
                 {
             
                     item.totalp = null;
                     item.totald = null;
 
                     this.actualizarTotales('MO')
             
                 }
 
             }



             if (tipo == 'DE')
             {
 
                 const cantidad3 = parseFloat(item.cantidad);
                 if (!isNaN(cantidad3)) 
                 {
                     item.cantidad = cantidad3; // Asegura que el valor sea numérico
                     if (!isNaN(item.peso)) 
                     {
                         item.totalp = (cantidad3 * item.pesos).toFixed(2);
                     }
                     if (!isNaN(item.dolar)) 
                     {
                         item.totald = (cantidad3 * item.dolar).toFixed(2);
                     }
 
                     
                     this.actualizarTotales('DE');
                 } 
                 else 
                 {
             
                     item.totalp = null;
                     item.totald = null;
 
                     this.actualizarTotales('DE')
             
                 }
 
             }
 
 
         },
 
 
         
 
 
         actualizarTotales(tipo) 
         {
             if (tipo == 'T')
             {
 
                  // Calcula la suma total de totalp y totald
                 this.totalpSum = this.desserts.reduce((sum, item) => sum + parseFloat(item.totalp || 0), 0);
                 this.totaldSum = this.desserts.reduce((sum, item) => sum + parseFloat(item.totald || 0), 0);
 
 
                 console.log(this.totalpSum.toFixed(2));
                 console.log(this.totaldSum.toFixed(2));
 
                 this.actualizarCantGI();
 
                 // Actualiza los valores de los totales en los datos
                 // this.desserts.forEach((item) => {
                 //     item.totalpSum = totalpSum;
                 //     item.totaldSum = totaldSum;
                 // });
 
             }
            
             if (tipo == 'Ter')
             {
 
                  // Calcula la suma total de totalp y totald
                 this.totalpSum1 = this.dessertsTer.reduce((sum, item) => sum + parseFloat(item.totalp || 0), 0);
                 this.totaldSum1 = this.dessertsTer.reduce((sum, item) => sum + parseFloat(item.totald || 0), 0);
 
 
                 console.log(this.totalpSum1.toFixed(2));
                 console.log(this.totaldSum1.toFixed(2));              
 
             }
 
 
 
             if (tipo == 'MO')
             {
 
                  // Calcula la suma total de totalp y totald
                 this.totalpSum2 = this.dessertsMO.reduce((sum, item) => sum + parseFloat(item.totalp || 0), 0);
                 this.totaldSum2 = this.dessertsMO.reduce((sum, item) => sum + parseFloat(item.totald || 0), 0);
 
 
                 console.log(this.totalpSum2.toFixed(2));
                 console.log(this.totaldSum2.toFixed(2));              
 
             }

            //  if (tipo == 'MV')
            //  {
 
            //       // Calcula la suma total de totalp y totald
            //      this.totalpSum3 = this.dessertsMV.reduce((sum, item) => sum + parseFloat(item.totalp || 0), 0);
            //      this.totaldSum3 = this.dessertsMV.reduce((sum, item) => sum + parseFloat(item.totald || 0), 0);
 
 
            //      console.log(this.totalpSum3.toFixed(2));
            //      console.log(this.totaldSum3.toFixed(2));              
 
            //  }


             if (tipo == 'DE')
             {
 
                  // Calcula la suma total de totalp y totald
                 this.totalpSum4 = this.dessertsDE.reduce((sum, item) => sum + parseFloat(item.totalp || 0), 0);
                 this.totaldSum4 = this.dessertsDE.reduce((sum, item) => sum + parseFloat(item.totald || 0), 0);
 
 
                 console.log(this.totalpSum4.toFixed(2));
                 console.log(this.totaldSum4.toFixed(2));              
 
             }
 
         },
 
         habilitar(tipo)
         {
             if(tipo == 'T')
             {
                 if (this.filtro == '1')
                 {
                     this.mtCan = true;
                     this.mtsCan = false;
                 }
                 if (this.filtro == '2')
                 {
                     this.mtCan = false;
                     this.mtsCan = true;
                 }
 
             }
 
 
             if(tipo == 'Ter')
             {
                 if (this.filtroTer == '1')
                 {
                     this.terCan = true;
                     this.tersCan = false;
                 }
                 if (this.filtroTer == '2')
                 {
                     this.terCan = false;
                     this.tersCan = true;
                 }
 
             }
 
             if(tipo == 'MO')
             {
                 if (this.filtroMO == '1')
                 {
                     this.moCan = true;
                     this.mosCan = false;
                 }
                 if (this.filtroMO == '2')
                 {
                     this.moCan = false;
                     this.mosCan = true;
                 }
 
             }

             if(tipo == 'MV')
             {
                 if (this.filtroMV == '1')
                 {
                     this.MvCan = true;
                     this.MvsCan = false;
                 }
                 if (this.filtroMV == '2')
                 {
                     this.MvCan = false;
                     this.MvsCan = true;
                 }
 
             }


             if(tipo == 'DE')
             {
                 if (this.filtroDE == '1')
                 {
                     this.mdCan = true;
                     this.mdsCan = false;
                 }
                 if (this.filtroDE == '2')
                 {
                     this.mdCan = false;
                     this.mdsCan = true;
                 }
 
             }
 
 
         },
 
 
         actualizarCantGI()
         {
 
             console.log(" estoy actualizarCantGI")
             const valorCantidadGI = this.cantidadGI;
             console.log(valorCantidadGI);
 
 
 
         },




         guardarNuevo()
         {


                let self = this;  


                console.log("array", this.desserts)

                console.log("array copia", this.dessertsOriginal)



                //const tildados = [];
                //const destildados = [];

              

                

              
                const nombresVacios1 = this.desserts.some(item => item.nombre.trim() === '');

                if (nombresVacios1) {  
                    this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                    return; // Evitar que se continúe con el proceso de guardado
                }

                const nombresVacios2 = this.dessertsTer.some(item => item.nombre.trim() === '');

                if (nombresVacios2) {  
                    this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                    return; // Evitar que se continúe con el proceso de guardado
                }

                const nombresVacios3 = this.dessertsGI.some(item => item.nombre.trim() === '');

                if (nombresVacios3) {  
                    this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                    return; // Evitar que se continúe con el proceso de guardado
                }

                const nombresVacios4 = this.dessertsMO.some(item => item.nombre.trim() === '');

                if (nombresVacios4) {  
                    this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                    return; // Evitar que se continúe con el proceso de guardado
                }

                // const nombresVacios5 = this.dessertsMV.some(item => item.nombre.trim() === '');

                // if (nombresVacios5) {  
                //     this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                //     return; // Evitar que se continúe con el proceso de guardado
                // }


                const nombresVacios6 = this.dessertsDE.some(item => item.nombre.trim() === '');

                if (nombresVacios6) {  
                    this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                    return; // Evitar que se continúe con el proceso de guardado
                }





                this.$swal({
                title: "Sistema de Fabricación",
                text: "¿Esta seguro de guardar los datos?",
                icon: "success",
                background: "#ececec",
                showClass: {
                popup: "animate__animated animate__fadeInDown"
                },
                hideClass: {
                popup: "animate__animated animate__fadeOutUp"
                },
                showCancelButton: true,
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then(result => 
                {

                    
                    if (result.value) 
                    { 

                            let aux =[];  //nuevo materiales
                            let aux1 =[];  // actualizar campos de material
                            let aux2 = []; // eliminar elementos

                          
                        


                            if (this.dessertBorrar.length > 0)
                            {
                                console.log("borrar");
                                console.log( this.dessertBorrar);

                                this.dessertBorrar.forEach(element => {

                                    aux2.push(
                                            {

                                                IdMate: element.id,
                                                Nombre: element.nombre,
                                                Pesos: element.pesos,
                                                Dolar: element.dolar,
                                                Fecha: element.fecha,                                                   
                                                CodigoMate: element.codigoMate,
                                                IdTipo:0,
                                                IdUni:1,
                                                IdGi :1,
                                                IdTaller: 0,
                                                Activo: 1,
                                                Id: element.id1 
                                                
                                            })

                                    
                                    
                                });

                            

                            }                          


                            let filtro1 = this.desserts.filter(item => item.dolar !== item.dolarA 
                            || item.pesos !== item.pesosA);


                            this.showLoadingAlert = true;


                            filtro1.forEach(element => {   
                                
                                if(element.id1 != 0)
                                {

                                        aux1.push(
                                        {

                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:1,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })


                                }
                                else
                                {
                                    if(element.id1 == 0)
                                    {


                                        aux.push(
                                        {

                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:1,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })


                                    }

                                }
                        
                            });


                            let filtro2 = this.dessertsTer.filter(item => item.dolar !== item.dolarA 
                                || item.pesos !== item.pesosA);


                            filtro2.forEach(element => {   
                                    
                                    if(element.id1 != 0)
                                    {

                                        aux1.push(
                                            {
                                                IdMate: element.id,
                                                Nombre: element.nombre,
                                                Pesos: element.pesos,
                                                Dolar: element.dolar,
                                                Fecha: '2021-01-01',                                                   
                                                CodigoMate: element.codigoMate,
                                                IdTipo:2,
                                                IdUni:1,
                                                IdGi :1,
                                                IdTaller: element.taller,
                                                Activo: 1,
                                                Id: element.id1 
                                                
                                            })

                                    }
                                    else
                                    {

                                        if(element.id1 == 0)
                                        {

                                            aux.push(
                                            {
                                                IdMate: element.id,
                                                Nombre: element.nombre,
                                                Pesos: element.pesos,
                                                Dolar: element.dolar,
                                                Fecha: '2021-01-01',                                                   
                                                CodigoMate: element.codigoMate,
                                                IdTipo:2,
                                                IdUni:1,
                                                IdGi :1,
                                                IdTaller: element.taller,
                                                Activo: 1,
                                                Id: element.id1 
                                                
                                            })

                                        }


                                    }                                 
                                
                            });

                            let filtro3 = this.dessertsGI.filter(item => item.dolar !== item.dolarA 
                                || item.pesos !== item.pesosA);


                            filtro3.forEach(element => {     
                                    
                                    if(element.id1 != 0)
                                    {

                                        aux1.push(
                                        {
                                                IdMate: element.id,
                                                Nombre: element.nombre,
                                                Pesos: element.pesos,
                                                Dolar: element.dolar,
                                                Fecha: '2021-01-01',                                                   
                                                CodigoMate: element.codigoMate,
                                                IdTipo:3,
                                                IdUni:1,
                                                IdGi :1,
                                                IdTaller: element.taller,
                                                Activo: 1,
                                                Id: element.id1 
                                                
                                        })


                                    }
                                    else
                                    {

                                        if(element.id1 == 0)
                                        {

                                                aux.push(
                                                {
                                                    IdMate: element.id,
                                                    Nombre: element.nombre,
                                                    Pesos: element.pesos,
                                                    Dolar: element.dolar,
                                                    Fecha: '2021-01-01',                                                   
                                                    CodigoMate: element.codigoMate,
                                                    IdTipo:3,
                                                    IdUni:1,
                                                    IdGi :1,
                                                    IdTaller: element.taller,
                                                    Activo: 1,
                                                    Id: element.id1 
                                                    
                                                })


                                        }


                                    }                                 
                                    
                            });

                            let filtro4 = this.dessertsMO.filter(item => item.dolar !== item.dolarA 
                            || item.pesos !== item.pesosA);


                            filtro4.forEach(element => {                           
                                    
                                    if(element.id1 != 0)
                                    {

                                        aux1.push(
                                            {
                                                IdMate: element.id,
                                                Nombre: element.nombre,
                                                Pesos: element.pesos,
                                                Dolar: element.dolar,
                                                Fecha: '2021-01-01',                                                   
                                                CodigoMate: element.codigoMate,
                                                IdTipo:4,
                                                IdUni:1,
                                                IdGi :1,
                                                IdTaller: element.taller,
                                                Activo: 1,
                                                Id: element.id1 
                                                
                                            })

                                    }
                                    else
                                    {

                                        if(element.id1 == 0)
                                        {

                                            aux.push(
                                            {
                                                IdMate: element.id,
                                                Nombre: element.nombre,
                                                Pesos: element.pesos,
                                                Dolar: element.dolar,
                                                Fecha: '2021-01-01',                                                   
                                                CodigoMate: element.codigoMate,
                                                IdTipo:4,
                                                IdUni:1,
                                                IdGi :1,
                                                IdTaller: element.taller,
                                                Activo: 1,
                                                Id: element.id1 
                                                
                                            })

                                        }

                                    }                              
                                    

                            });
                         

                          
                            
                            


                            let filtro6 = this.dessertsDE.filter(item => item.dolar !== item.dolarA 
                            || item.pesos !== item.pesosA);


                            filtro6.forEach(element => {                           
                                    
                                    if( element.id1 != 0 )
                                    {
                                        aux1.push(
                                            {
                                                IdMate: element.id,
                                                Nombre: element.nombre,
                                                Pesos: element.pesos,
                                                Dolar: element.dolar,
                                                Fecha: '2021-01-01',                                                   
                                                CodigoMate: element.codigoMate,
                                                IdTipo:6,
                                                IdUni:1,
                                                IdGi :1,
                                                IdTaller: element.taller,
                                                Activo: 1,
                                                Id: element.id1 
                                                
                                            })
                                    }

                                    else
                                    {

                                        if( element.id1 == 0 )
                                        {

                                            aux.push(
                                            {
                                                IdMate: element.id,
                                                Nombre: element.nombre,
                                                Pesos: element.pesos,
                                                Dolar: element.dolar,
                                                Fecha: '2021-01-01',                                                   
                                                CodigoMate: element.codigoMate,
                                                IdTipo:6,
                                                IdUni:1,
                                                IdGi :1,
                                                IdTaller: element.taller,
                                                Activo: 1,
                                                Id: element.id1 
                                                
                                            })
                                    

                                        }


                                    }

                                
                                    

                            });                         
                            
                            console.log(aux);
                            console.log(aux1);
                            console.log(aux2);
                            


                            this.detectarCambios(1); // mat de taller

                            this.detectarCambios(2); // serv de terceros

                            this.detectarCambios(4); // mano de obra

                            this.detectarCambios(6); // provision deposito




                            if (this.tildados.length > 0 || this.destildados.length > 0) {

                                console.log("Materiales modificados:");
                                console.log("Tildados:", this.tildados);
                                console.log("Destildados:", this.destildados);

                                // Aquí puedes agregar lógica para guardar los cambios


                            } else {
                                console.log("No hay cambios en los materiales.");
                            }

                        
                            let Modelo = {

                                
                                FabMateMaterial1: aux  ,
                                FabMateMaterial2: aux1  ,
                                FabMateMaterial3: aux2,
                                FabMateMaterial4: this.tildados,
                                FabMateMaterial5: this.destildados,
                                Tipo : 1 

                            
                            }


                            
                            console.log(Modelo);

                        
                            Axios                            
                            .post("/Fabricacion/GuardarFabMaterial_Nuevo1", Modelo)                                                       
                            .then((response) => 
                            {

                                this.tildados = [];
                                this.destildados = [];
                            
                                console.log("paso")                         
                                this.cargar_Plantilla();   


                                this.showLoadingAlert = false;

                                this.$swal("", "Los materiales se guardaron con exito", "info")

                            
                            })

                            

                            .catch((error) => {                            
                                console.log(error);
                            });                     
                        

                    
                    }

                });





         },
         
 
 
         Guardar(tipo)
         {
 
 
            let self = this;    



            if(tipo == 11 || tipo == 22)
            {
                const nombresVacios = this.desserts.some(item => item.nombre.trim() === '');

                if (nombresVacios) {  
                    this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                    return; // Evitar que se continúe con el proceso de guardado
                }

            } 


            if(tipo == 2)
            {
                const nombresVacios = this.dessertsTer.some(item => item.nombre.trim() === '');

                if (nombresVacios) {  
                    this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                    return; // Evitar que se continúe con el proceso de guardado
                }

            } 

            if(tipo == 3)
            {
                const nombresVacios = this.dessertsGI.some(item => item.nombre.trim() === '');

                if (nombresVacios) {  
                    this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                    return; // Evitar que se continúe con el proceso de guardado
                }

            } 



            if(tipo == 4)
            {
                const nombresVacios = this.dessertsMO.some(item => item.nombre.trim() === '');

                if (nombresVacios) {  
                    this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                    return; // Evitar que se continúe con el proceso de guardado
                }

            } 



            // if(tipo == 5)
            // {
            //     const nombresVacios = this.dessertsMV.some(item => item.nombre.trim() === '');

            //     if (nombresVacios) {  
            //         this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
            //         return; // Evitar que se continúe con el proceso de guardado
            //     }

            // } 


            if(tipo == 6)
            {
                const nombresVacios = this.dessertsDE.some(item => item.nombre.trim() === '');

                if (nombresVacios) {  
                    this.$swal("", "Por favor, completa todos los nombres antes de guardar.", "info")               
                    return; // Evitar que se continúe con el proceso de guardado
                }

            } 
            
             this.$swal({
             title: "Sistema de Fabricación",
             text: "¿Esta seguro de guardar los datos?",
             icon: "success",
             background: "#ececec",
             showClass: {
             popup: "animate__animated animate__fadeInDown"
             },
             hideClass: {
             popup: "animate__animated animate__fadeOutUp"
             },
             showCancelButton: true,
             confirmButtonText: "Si",
             cancelButtonText: "No",
             showCloseButton: true,
             showLoaderOnConfirm: true
             }).then(result => 
             {
 
                 
                 if (result.value) 
                 { 
 
                        let aux =[];  //nuevo materiales
                        let aux1 =[];  // actualizar campos de material
                        let aux2 = []; // eliminar elementos
                        
                        let filtro =[];


                        if (this.dessertBorrar.length > 0)
                        {
                            console.log("borrar");
                            console.log( this.dessertBorrar);

                            this.dessertBorrar.forEach(element => {

                                aux2.push(
                                        {

                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: element.fecha,                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:0,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: 0,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })

                                
                                
                            });

                          

                        }

                        console.log("borrar que cargo");
                        console.log(aux2);
 
                        if(tipo == 11 || tipo == 22)
                        {



                            filtro = this.desserts.filter(item => item.dolar !== item.dolarA 
                            || item.pesos !== item.pesosA);


                            filtro.forEach(element => {   
                                
                                if(element.id1 != 0)
                                {

                                        aux1.push(
                                        {

                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:1,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })


                                }
                                else
                                {
                                    if(element.id1 == 0)
                                    {


                                        aux.push(
                                        {

                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:1,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })


                                    }

                                }
                           
                             });


                        }


                        
                        if(tipo == 2)
                        {


                            filtro = this.dessertsTer.filter(item => item.dolar !== item.dolarA 
                            || item.pesos !== item.pesosA);


                            filtro.forEach(element => {   
                                
                                if(element.id1 != 0)
                                {

                                    aux1.push(
                                        {
                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:2,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })

                                }
                                else
                                {

                                    if(element.id1 == 0)
                                    {

                                        aux.push(
                                        {
                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:2,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })

                                    }


                                }                                 
                               
                            });


                        }

                        if(tipo == 3)
                        {


                            filtro = this.dessertsGI.filter(item => item.dolar !== item.dolarA 
                            || item.pesos !== item.pesosA);


                            filtro.forEach(element => {     
                                
                                if(element.id1 != 0)
                                {

                                    aux1.push(
                                    {
                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:3,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                    })


                                }
                                else
                                {

                                    if(element.id1 == 0)
                                    {

                                            aux.push(
                                            {
                                                IdMate: element.id,
                                                Nombre: element.nombre,
                                                Pesos: element.pesos,
                                                Dolar: element.dolar,
                                                Fecha: '2021-01-01',                                                   
                                                CodigoMate: element.codigoMate,
                                                IdTipo:3,
                                                IdUni:1,
                                                IdGi :1,
                                                IdTaller: element.taller,
                                                Activo: 1,
                                                Id: element.id1 
                                                
                                            })


                                    }


                                }                                 
                                
                            });
                        }


                        if(tipo == 4)
                        {

                            filtro = this.dessertsMO.filter(item => item.dolar !== item.dolarA 
                            || item.pesos !== item.pesosA);


                            filtro.forEach(element => {                           
                                  
                                if(element.id1 != 0)
                                {

                                    aux1.push(
                                        {
                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:4,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })

                                }
                                else
                                {

                                    if(element.id1 == 0)
                                    {

                                        aux.push(
                                        {
                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:4,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })

                                    }

                                }                              
                                   
 
                             });
                        }



                        // if(tipo == 5)
                        // {


                        //     console.log(this.dessertsMV);

                        //     filtro = this.dessertsMV.filter(item => item.dolar !== item.dolarA 
                        //     || item.pesos !== item.pesosA);


                        //     filtro.forEach(element => {                           
                                  
                        //         if( element.id1 != 0 )
                        //         {
                        //             aux1.push(
                        //                 {
                        //                     IdMate: element.id,
                        //                     Nombre: element.nombre,
                        //                     Pesos: element.pesos,
                        //                     Dolar: element.dolar,
                        //                     Fecha: '2021-01-01',                                                   
                        //                     CodigoMate: element.codigoMate,
                        //                     IdTipo:5,
                        //                     IdUni:1,
                        //                     IdGi :1,
                        //                     IdTaller: element.taller,
                        //                     Activo: 1,
                        //                     Id: element.id1 
                                            
                        //                 })
                        //         }

                        //         else
                        //         {

                        //             if( element.id1 == 0 )
                        //             {

                        //                 aux.push(
                        //                 {
                        //                     IdMate: element.id,
                        //                     Nombre: element.nombre,
                        //                     Pesos: element.pesos,
                        //                     Dolar: element.dolar,
                        //                     Fecha: '2021-01-01',                                                   
                        //                     CodigoMate: element.codigoMate,
                        //                     IdTipo:5,
                        //                     IdUni:1,
                        //                     IdGi :1,
                        //                     IdTaller: element.taller,
                        //                     Activo: 1,
                        //                     Id: element.id1 
                                            
                        //                 })
                                

                        //             }


                        //         }

                            
                                   
 
                        //      });                                       

                        // }





                        if(tipo == 6)
                        {


                            console.log(this.dessertsDE);

                            filtro = this.dessertsDE.filter(item => item.dolar !== item.dolarA 
                            || item.pesos !== item.pesosA);


                            filtro.forEach(element => {                           
                                  
                                if( element.id1 != 0 )
                                {
                                    aux1.push(
                                        {
                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:6,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })
                                }

                                else
                                {

                                    if( element.id1 == 0 )
                                    {

                                        aux.push(
                                        {
                                            IdMate: element.id,
                                            Nombre: element.nombre,
                                            Pesos: element.pesos,
                                            Dolar: element.dolar,
                                            Fecha: '2021-01-01',                                                   
                                            CodigoMate: element.codigoMate,
                                            IdTipo:6,
                                            IdUni:1,
                                            IdGi :1,
                                            IdTaller: element.taller,
                                            Activo: 1,
                                            Id: element.id1 
                                            
                                        })
                                

                                    }


                                }

                            
                                   
 
                             });                                       

                        }


                        console.log(aux);
                        console.log(aux1);
                        console.log(aux2);
                       
                        let Modelo = {
 
                             
                             FabMateMaterial1: aux  ,
                             FabMateMaterial2: aux1  ,
                             FabMateMaterial3: aux2,
                             Tipo : tipo 

                         
                        }
 
 
                        
                        console.log(Modelo);
 
                     
                        Axios                            
                         .post("/Fabricacion/GuardarFabMaterial_Nuevo", Modelo)                                                       
                         .then((response) => 
                         {
                         
                         console.log("paso")


                         if(tipo == 11 || tipo == 22)
                         {
                            this.desserts = [];
                            this.return_Plantilla("1");
                         }
                             
                         
                         if (tipo == 2) 
                         {
                                this.dessertsTer=[];
                                this.return_Plantilla("2");   

                         }


                         if (tipo == 3) 
                         {
                                this.dessertsGI=[];
                                this.return_Plantilla("3");   

                         }


                         
                         if (tipo == 4) 
                         {
                                this.dessertsMO=[];
                                this.return_Plantilla("4");   

                         }   
                         
                         

                        //  if (tipo == 5) 
                        //  {
                        //         this.dessertsMV=[];
                        //         this.return_Plantilla("5");   

                        //  }    



                         if (tipo == 6) 
                         {
                                this.dessertsDE=[];
                                this.return_Plantilla("6");   

                         }    
 
                             
                         this.$swal("", "Los materiales se guardaron con exito", "info")
 
                         
                         
 
 
                         
                         
                         })
 
                         
 
                         .catch((error) => {                            
                             console.log(error);
                         });                     
                     
 
                 
                 }
 
             });
 
 
 
         },


         convertirAMayusculas(carac, tipo)
         {
            //taller
            if (tipo == 1 ) 
            {
                 this.search = this.search.toUpperCase();
            }

            //serv terc
            if (tipo == 2) 
            {
                 this.search1 = this.search1.toUpperCase();
            }


             //mo
             if (tipo == 3) 
            {
                 this.search2 = this.search2.toUpperCase();
            }


            //mV
            if (tipo == 5) 
            {
                 this.search3 = this.search3.toUpperCase();
            }


             //DE
             if (tipo == 6) 
            {
                 this.search4 = this.search4.toUpperCase();
            }


         },
         
         
         agregarFila(tipo)
         {
            if(tipo == 11 || tipo == 22)
            {
                console.log("pasoooo")

                this.tipoTaller= tipo;

                const nuevaFila = {
                    codigoMate: tipo == 11 ? 'Chapa' : 'Materiales',
                    nombre: '',
                    pesos: '',
                    dolar: '',
                };

                this.desserts.push(nuevaFila); // Cambiado a push
                this.nuevaFila = nuevaFila;



            }

            if(tipo == 2)
            {
                console.log("pasoooo")
                this.dessertsTer.push({
                    nombre:'',
                    pesos:'',
                    dolar:''
                })
            }
            if(tipo == 4)
            {
                console.log("pasoooo")
                this.dessertsMO.push({
                    nombre:'',
                    pesos:'',
                    dolar:''
                })
            }
            // if(tipo == 5)
            // {
            //     console.log("pasoooo mv")
            //     this.dessertsMV.push({
            //         nombre:'',
            //         pesos:'',
            //         dolar:''
            //     })
            // }
            if(tipo == 6)
            {
                console.log("pasoooo mv")
                this.dessertsDE.push({
                    nombre:'',
                    pesos:'',
                    dolar:''
                })
            }

         },

         deleteItem (item,tipo) 
         {
            let dessertEliminado = [];

            if (tipo == 1)
            {
                this.editedIndex = this.desserts.indexOf(item)
                dessertEliminado = this.desserts.splice(this.editedIndex, 1);

                dessertEliminado.forEach(element => {

                    this.dessertBorrar.push(
                        {

                            id : element.id,
                            nombre: element.nombre,
                            pesos : element.pesos,
                            dolar : element.dolar,
                            fecha : element.fecha,                                                   
                            codigoMate : element.codigoMate,                          
                            id1 : element.id1 
                        }    

                    )

                });

               // this.dessertBorrar.push(dessertEliminado);                            
            }

            if (tipo == 2)
            {
                this.editedIndex = this.dessertsTer.indexOf(item)
                dessertEliminado = this.dessertsTer.splice(this.editedIndex, 1);

                dessertEliminado.forEach(element => {

                this.dessertBorrar.push(
                    {

                        id : element.id,
                        nombre: element.nombre,
                        pesos : element.pesos,
                        dolar : element.dolar,
                        fecha : element.fecha,                                                   
                        codigoMate : element.codigoMate,                          
                        id1 : element.id1 
                    }    

                )

                });

                //this.dessertBorrar.push(dessertEliminado);          
                             
            }

            if (tipo == 3)
            {
                this.editedIndex = this.dessertsGI.indexOf(item)
                dessertEliminado =   this.dessertsGI.splice(this.editedIndex, 1);

                dessertEliminado.forEach(element => {

                this.dessertBorrar.push(
                    {

                        id : element.id,
                        nombre: element.nombre,
                        pesos : element.pesos,
                        dolar : element.dolar,
                        fecha : element.fecha,                                                   
                        codigoMate : element.codigoMate,                          
                        id1 : element.id1 
                    }    

                )

                });

                //this.dessertBorrar.push(dessertEliminado);                  
                          
            }

            if (tipo == 4)
            {
                this.editedIndex = this.dessertsMO.indexOf(item)
                dessertEliminado = this.dessertsMO.splice(this.editedIndex, 1);

                dessertEliminado.forEach(element => {

                this.dessertBorrar.push(
                    {

                        id : element.id,
                        nombre: element.nombre,
                        pesos : element.pesos,
                        dolar : element.dolar,
                        fecha : element.fecha,                                                   
                        codigoMate : element.codigoMate,                          
                        id1 : element.id1 
                    }    

                )

                });

                //this.dessertBorrar.push(dessertEliminado);                  
                             
            }

            // if (tipo == 5)
            // {
            //     this.editedIndex = this.dessertsMV.indexOf(item)
            //     dessertEliminado =  this.dessertsMV.splice(this.editedIndex, 1);

            //     dessertEliminado.forEach(element => {

            //     this.dessertBorrar.push(
            //         {

            //             id : element.id,
            //             nombre: element.nombre,
            //             pesos : element.pesos,
            //             dolar : element.dolar,
            //             fecha : element.fecha,                                                   
            //             codigoMate : element.codigoMate,                          
            //             id1 : element.id1 
            //         }    

            //     )

            //     });


            //     //this.dessertBorrar.push(dessertEliminado);                  
                              
            // }



            if (tipo == 6)
            {
                this.editedIndex = this.dessertsDE.indexOf(item)
                dessertEliminado =  this.dessertsDE.splice(this.editedIndex, 1);

                dessertEliminado.forEach(element => {

                this.dessertBorrar.push(
                    {

                        id : element.id,
                        nombre: element.nombre,
                        pesos : element.pesos,
                        dolar : element.dolar,
                        fecha : element.fecha,                                                   
                        codigoMate : element.codigoMate,                          
                        id1 : element.id1 
                    }    

                )

                });


                //this.dessertBorrar.push(dessertEliminado);                  
                              
            }





            console.log(this.dessertBorrar);
        },

        

        return_Plantilla(tipo)
        {
                
                let self = this;  
                if(tipo == "1" )
                {  
                        console.log("estoy en fabricacion")
                        Axios
                        .get("/Plantilla/GetPlantilla?", {
                        params: {
                            id: '1',
                        },
                        })
                        
                        .then((r) => {             
                            
                            console.log(r.data); 
                            this.desserts = r.data;
                            console.log(this.desserts);
                                
                        })
                        .catch((error) => {
                            console.log("error no pasa")                  
                        }); 
                 
 
                }


                if(tipo == "2" )
                {
                    console.log("estoy en terceros")
                    Axios
                    .get("/Plantilla/GetPlantilla?", {
                    params: {
                        id: '2',
                    },
                    })
                    
                    .then((r) => {             
                        
                        console.log(r.data); 
                        this.dessertsTer = r.data;
                            
                    })
                    .catch((error) => {
                        console.log("error no pasa")                  
                    }); 
    
        

                }



                if(tipo == "3" )
                {
                    console.log("estoy en terceros")
                    Axios
                    .get("/Plantilla/GetPlantilla?", {
                    params: {
                        id: '3',
                    },
                    })
                    
                    .then((r) => {             
                        
                        console.log(r.data); 
                        this.dessertsGI = r.data;
                            
                    })
                    .catch((error) => {
                        console.log("error no pasa")                  
                    }); 
    
        

                }




                if(tipo =="4")
                {
                        console.log("estoy en mano de obra")
                        Axios
                        .get("/Plantilla/GetPlantilla?", {
                        params: {
                            id: '4',
                        },
                        })
                        
                        .then((r) => {             
                            
                            console.log(r.data); 
                            this.dessertsMO = r.data;
                                
                        })
                        .catch((error) => {
                            console.log("error no pasa")                  
                        }); 
                    
     
                }


                // if(tipo =="5")
                // {
                //         console.log("estoy en mat varios")
                //         Axios
                //         .get("/Plantilla/GetPlantilla?", {
                //         params: {
                //             id: '5',
                //         },
                //         })
                        
                //         .then((r) => {             
                            
                //             console.log(r.data); 
                //             this.dessertsMV = r.data;
                                
                //         })
                //         .catch((error) => {
                //             console.log("error no pasa")                  
                //         }); 
                    
     
                // }



                if(tipo =="6")
                {
                        console.log("estoy en deposito")
                        Axios
                        .get("/Plantilla/GetPlantilla?", {
                        params: {
                            id: '6',
                        },
                        })
                        
                        .then((r) => {             
                            
                            console.log(r.data); 
                            this.dessertsDE = r.data;
                                
                        })
                        .catch((error) => {
                            console.log("error no pasa")                  
                        }); 
                    
     
                }



        },


        
        elementosModificado(tipo)
        {
             console.log("estoy en elementosModificado")
             //Taller   
             if(tipo == 1)
             {

                    let itemsFiltrados = this.desserts.filter(item => item.dolar !== item.dolarA 
                    || item.pesos !== item.pesosA);

                    console.log(itemsFiltrados);

             }
           


        },


        applyPriceAdjustment() {
            console.log("categoria seleccionado", this.selectedCategory)

            if (this.selectedOption === "category" && this.selectedCategory && this.categoryPercentage) {
                // Lógica para aplicar el ajuste por categoría
                console.log(`Ajustar precios en la categoría ${this.selectedCategory} por ${this.categoryPercentage}%`);
                if (this.selectedCategory =="Taller")
                {
                        console.log("entro taller");
                        this.desserts.forEach(element => {
                            
                            element.pesos =  this.roundToDecimal((element.pesos * (this.categoryPercentage/100) + element.pesos),2);
                            element.dolar = this.roundToDecimal((element.dolar * (this.categoryPercentage/100) + element.dolar),2);

                        });

                }
                if (this.selectedCategory =="Tercero")
                {       


                        console.log("entro tercero");
    
                        this.dessertsTer.forEach(element => {
                            
                            element.pesos = this.roundToDecimal( (element.pesos * (this.categoryPercentage/100) + element.pesos),2);
                            element.dolar = this.roundToDecimal(  (element.dolar * (this.categoryPercentage/100) + element.dolar),2);

                        });
                    
                }
                if (this.selectedCategory =="Mano Obra")
                {
                    
                    console.log("entro mo");
                    this.dessertsMO.forEach(element => {
                            
                            element.pesos = this.roundToDecimal((element.pesos * (this.categoryPercentage/100) + element.pesos),2);
                            element.dolar = this.roundToDecimal(  (element.dolar * (this.categoryPercentage/100) + element.dolar),2);

                        });

                }
                if (this.selectedCategory =="Gastos Indirecto")
                {
                    
                    console.log("entro gi");

                    this.dessertsGI.forEach(element => {
                            
                            element.pesos = this.roundToDecimal( (element.pesos * (this.categoryPercentage/100) + element.pesos),2);
                            element.dolar = this.roundToDecimal(  (element.dolar * (this.categoryPercentage/100) + element.dolar),2);

                        });

                }
                if (this.selectedCategory =="Deposito")
                {
                    
                    console.log("entro deposito");

                    this.dessertsDE.forEach(element => {
                            
                            element.pesos = this.roundToDecimal( (element.pesos * (this.categoryPercentage/100) + element.pesos),2);
                            element.dolar = this.roundToDecimal(  (element.dolar * (this.categoryPercentage/100) + element.dolar),2);

                        });

                }

            } else if (this.selectedOption === "general" && this.generalPercentage) {
                // Lógica para aplicar el ajuste general
                console.log(`Ajustar todos los precios por ${this.generalPercentage}%`);

                this.desserts.forEach(element => {
                            
                            element.pesos = this.roundToDecimal( (element.pesos * (this.generalPercentage/100) + element.pesos),2);
                            element.dolar = this.roundToDecimal( (element.dolar * (this.generalPercentage/100) + element.dolar),2);

                });

                this.dessertsTer.forEach(element => {
                            
                            element.pesos = this.roundToDecimal( (element.pesos * (this.generalPercentage/100) + element.pesos),2);
                            element.dolar = this.roundToDecimal( (element.dolar * (this.generalPercentage/100) + element.dolar),2);

                        });


                this.dessertsMO.forEach(element => {
                    
                    element.pesos = this.roundToDecimal((element.pesos * (this.generalPercentage/100) + element.pesos),2);
                    element.dolar =  this.roundToDecimal((element.dolar * (this.generalPercentage/100) + element.dolar),2);

                });


                this.dessertsGI.forEach(element => {
                            
                            element.pesos = this.roundToDecimal( (element.pesos * (this.generalPercentage/100) + element.pesos),2);
                            element.dolar = this.roundToDecimal( (element.dolar * (this.generalPercentage/100) + element.dolar),2);

                });

                this.dessertsDE.forEach(element => {
                    
                    element.pesos = this.roundToDecimal((element.pesos * (this.generalPercentage/100) + element.pesos),2);
                    element.dolar =  this.roundToDecimal((element.dolar * (this.generalPercentage/100) + element.dolar),2);

                });
       


            } else {
                // Manejar error o falta de datos
                console.error("Por favor, complete todos los campos requeridos");
                this.$swal("", "Por favor, complete todos los campos requeridos", "info")               
            }


            
        },




        roundToDecimal(number, decimals)
         {
            let factor = Math.pow(10, decimals);
            return Math.round(number * factor) / factor;
        },





        detectarCambios(tipo) {

            if(tipo == 1) //materiales de taller
            {	            
                

                this.desserts.forEach((item) => {
                    if (item.idproducto1 !== item.idproducto1A) {
                        if (item.idproducto1) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto1: item.idproducto1,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        } else {

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto1: item.idproducto1,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        }
                    }

                    if (item.idproducto2 !== item.idproducto2A) {
                        if (item.idproducto2) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto2: item.idproducto2,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        } else {

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto2: item.idproducto2,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        }
                    }

                    if (item.idproducto3 !== item.idproducto3A) {
                        if (item.idproducto3) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto3: item.idproducto3,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        } else {
                           
                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto3: item.idproducto3,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        }
                    }

                    if (item.idproducto4 !== item.idproducto4A) {
                        if (item.idproducto4) {
                           
                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto4: item.idproducto4,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });    


                        } else {
                           

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto4: item.idproducto4,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo

                            });


                        }
                    }
                });   


            } 
            
            

            if(tipo == 2) // servicios de terceros
            {	            
                

                this.dessertsTer.forEach((item) => {
                    if (item.idproducto1 !== item.idproducto1A) {
                        if (item.idproducto1) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto1: item.idproducto1,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        } else {

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto1: item.idproducto1,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        }
                    }

                    if (item.idproducto2 !== item.idproducto2A) {
                        if (item.idproducto2) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto2: item.idproducto2,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        } else {

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto2: item.idproducto2,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        }
                    }

                    if (item.idproducto3 !== item.idproducto3A) {
                        if (item.idproducto3) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto3: item.idproducto3,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        } else {
                           
                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto3: item.idproducto3,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        }
                    }

                    if (item.idproducto4 !== item.idproducto4A) {
                        if (item.idproducto4) {
                           
                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto4: item.idproducto4,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });    


                        } else {
                           

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto4: item.idproducto4,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        }
                    }
                });   


            } 




            if(tipo == 4) // mano de obra
            {	            
                

                this.dessertsMO.forEach((item) => {
                    if (item.idproducto1 !== item.idproducto1A) {
                        if (item.idproducto1) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto1: item.idproducto1,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        } else {

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto1: item.idproducto1,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        }
                    }

                    if (item.idproducto2 !== item.idproducto2A) {
                        if (item.idproducto2) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto2: item.idproducto2,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        } else {

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto2: item.idproducto2,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        }
                    }

                    if (item.idproducto3 !== item.idproducto3A) {
                        if (item.idproducto3) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto3: item.idproducto3,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        } else {
                           
                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto3: item.idproducto3,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        }
                    }

                    if (item.idproducto4 !== item.idproducto4A) {
                        if (item.idproducto4) {
                           
                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto4: item.idproducto4,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });    


                        } else {
                           

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto4: item.idproducto4,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        }
                    }
                });   


            } 



            if(tipo == 6) // provision deposito
            {	            
                

                this.dessertsDE.forEach((item) => {
                    if (item.idproducto1 !== item.idproducto1A) {
                        if (item.idproducto1) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto1: item.idproducto1,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        } else {

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto1: item.idproducto1,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        }
                    }

                    if (item.idproducto2 !== item.idproducto2A) {
                        if (item.idproducto2) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto2: item.idproducto2,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        } else {

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto2: item.idproducto2,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        }
                    }

                    if (item.idproducto3 !== item.idproducto3A) {
                        if (item.idproducto3) {

                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto3: item.idproducto3,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        } else {
                           
                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto3: item.idproducto3,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });

                        }
                    }

                    if (item.idproducto4 !== item.idproducto4A) {
                        if (item.idproducto4) {
                           
                            this.tildados.push({
                                codigoMate: item.codigoMate,
                                idproducto4: item.idproducto4,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });    


                        } else {
                           

                            this.destildados.push({
                                codigoMate: item.codigoMate,
                                idproducto4: item.idproducto4,
                                id: item.id,
                                id1: item.id1,
                                idtipo: tipo,

                            });


                        }
                    }
                });   


            } 





            console.log("Tildados:", this.tildados);
            console.log("Destildados:", this.destildados);


        },



        


 
     },   
 }
 </script>
 
 <style scoped>
 .fila-amarilla {
   background-color: #ffffcc !important; /* !important para anular cualquier estilo predeterminado */
 }
 </style>